import React from 'react'

import EntityDetailItem from 'syft-acp-core/components/EntityDetail/EntityDetailItem'

const ListingNoJobs = () => <EntityDetailItem padded>No Jobs</EntityDetailItem>

export default ListingNoJobs
